import React from "react";

import type { CustomInnerHeaderProps } from "ag-grid-react";

import QuestionMarkIcon from "assets/svg/questionmark-icon.svg";
import ClockIcon from "components/svg-icons/clock-icon";
import SubmittalLinksColLegend from "components/svg-icons/submittal-links-col-legend";
import TickIcon from "components/svg-icons/tick-icon";
import { Popover } from "antd";

type MyCustomInnerHeaderProps = CustomInnerHeaderProps;

function PopoverContent() {
  return (
    <div>
      <div>
        <SubmittalLinksColLegend />
      </div>
      <div className="mt-2 text-xs space-y-1">
        <div>
          1) <span className="italic">Submitted by Subcontractor Date</span>
        </div>
        <div>
          2) <span className="italic">Design Review Complete Date</span>
        </div>
        <div className="flex space-x-1">
          <div>3)</div>
          <div>
            <div>
              <ClockIcon />
              <span className="italic ml-1">Milestone Not Completed</span>
            </div>
            <div>
              <TickIcon /> <span className="italic">Milestone Completed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function LinkedSubmittalInnerHeader(
  props: MyCustomInnerHeaderProps
) {
  const { displayName } = props;
  return (
    <div className="customInnerHeader flex items-center space-x-2">
      <span className="w-[330px]">{displayName}</span>
      <Popover
        placement="left"
        content={<PopoverContent />}
        className="float-right"
      >
        <img
          src={QuestionMarkIcon}
          className="ag-header-icon -mt-0.5 mr-1"
          alt="Question Mark Icon"
        />
      </Popover>
    </div>
  );
}
